import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  href: "https://oculai.de",
  target: "_blank"
}
const _hoisted_2 = ["src"]

import logoMultipleNoPaddingSrc from "shared/assets/logo/oculai.svg";

export default /*#__PURE__*/_defineComponent({
  __name: 'LogoWatermark',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", _hoisted_1, [
    _createElementVNode("img", {
      class: "w-[100px] bg-white p-2 rounded opacity-80",
      src: _unref(logoMultipleNoPaddingSrc),
      alt: "oculai logo"
    }, null, 8, _hoisted_2)
  ]))
}
}

})